// Mock data for vibes
export const mockVibes = [
    { id: '1', name: 'Ride-Or-Die', emoji: '🖤', tag: 'loyalty' },
    { id: '2', name: 'Life-Saver', emoji: '🎖️', tag: 'heroic' },
    { id: '3', name: 'Ultimate Hype Beast', emoji: '😈', tag: 'energy' },
    { id: '4', name: 'Chaotic but Lovable Friend', emoji: '🤡', tag: 'fun' },
    { id: '5', name: 'Mysterious', emoji: '🎭', tag: 'enigmatic' },
    { id: '6', name: 'Pure Sunshine', emoji: '☀️', tag: 'positive' }
];

// Mock contact data
export const mockContact = {
    userId: '101',
    name: 'Alex',
    username: '@alex_j',
    profilePhoto: 'https://images.unsplash.com/photo-1544723795-3fb6469f5b39?w=150&h=150&fit=crop&crop=face'
};

// Utility functions
export function shuffleArray(array) {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
}

export function getRandomItems(array, count) {
    return shuffleArray(array).slice(0, count);
}